$(document).ready(function(){
    // Set aria-label for newsletter input
$('input#footer_newsletter_email').attr('aria-label', 'Enter your email to subscribe to the newsletter');

// Set aria-labels for product links
$('a.product-item-image-link[href="/collections/all/products/4-pack-crayons-in-box"]').attr('aria-label', 'View 4 pack crayons in box product details');
$('a.product-item-image-link[href="/collections/all/products/4-pack-crayons-in-cello-bag"]').attr('aria-label', 'View 4 pack crayons in cello bag product details');
$('a.product-item-image-link[href="/collections/all/products/2-pack-crayons-in-cello-bag"]').attr('aria-label', 'View 2 pack crayons in cello bag product details');
$('a.product-item-image-link[href="/collections/all/products/bulk-individual-crayons"]').attr('aria-label', 'View bulk individual crayons product details');
$('a.product-item-image-link[href="/collections/all/products/3-pack-crayons-in-cello-bag"]').attr('aria-label', 'View 3 pack crayons in cello bag product details');
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}

$("a.slideshow-slide-link-button.slideshow-slide-link-button-primary").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
// Set aria-labels for product links
$('a.product-item-image-link[href="/collections/4-packs/products/4-pack-crayons-in-cello-bag"]').attr('aria-label', 'View 4 pack crayons in cello bag product details');
$('a.product-item-image-link[href="/collections/4-packs/products/4-pack-crayons-in-box"]').attr('aria-label', 'View 4 pack crayons in box product details');
$('a.product-item-image-link[href="/collections/all/products/bold-test-product-with-variants"]').attr('aria-label', 'test product with variants');



// Set alt attribute for image
$('img[src="https://cdn.shopify.com/s/files/1/0288/6867/3624/files/about_us_page.jpg?v=1589569523"]').attr('alt', 'Two girls smiling and posing for a picture');
$('button.product-cards-pagination-next').attr('aria-label', 'Go to next product page');
$('img[src="//crayonking.com/cdn/shop/files/crayonking_logo_white_space_227x130.jpg?v=1614372669"]').attr('alt', 'Crayon King logo');
$('a.collection-item-image-link[href="/collections/2-packs"]').attr('aria-label', 'View 2 pack crayons collection');
$('a.collection-item-image-link[href="/collections/3-packs"]').attr('aria-label', 'View 3 pack crayons collection');
$('a.collection-item-image-link[href="/collections/4-packs"]').attr('aria-label', 'View 4 pack crayons collection');
$('a.collection-item-image-link[href="/collections/all"]').attr('aria-label', 'View all crayons collection');
$('a.collection-item-image-link[href="/collections/cello-packaging"]').attr('aria-label', 'View cello packaging crayons collection');
$('a.collection-item-image-link[href="/collections/bulk-packs"]').attr('aria-label', 'View bulk pack crayons collection');
$('a.collection-item-image-link[href="/collections/box-packaging"]').attr('aria-label', 'View box packaging crayons collection');
$('a.collection-item-image-link[href="/collections/frontpage"]').attr('aria-label', 'View featured crayons collection');

console.log("ready");
});
